<script>
export default {
  name: "InnerRadioPlus",
  functional: true,
  render: function (h, { props, parent, children, listeners, ...args }) {
    const { name, enumValues, value, disabled = false, showLabel } = props;
    const change = listeners.change;
    return (<div class="scence_ctr_box">
      {name && showLabel && <span class="scence_ctr_span_title">{name}</span>}
      {enumValues.map(el =>
        <el-radio onChange={() => change(el.Value)} disabled={!!disabled} value={value} label={el.Value} key={el.Value}>{el.Name}</el-radio>
      )}
    </div>

    )
  }
}
</script>
<style lang="scss">
@import "~@/components/button/comps-button.scss";

.scence_ctr_box {
  display: flex;
  align-items: baseline;
  // padding-left: 26px;

}
</style>
